module.exports = __webpack_public_path__ + "img/SAP_8874.f9f1a61c.jpg";